import React from "react";

// Ambient artistic swirl backdrop — flowing gradient blobs + a slow conic swirl.
// Pure CSS animation (GPU transforms), respects prefers-reduced-motion.
export const AuroraSwirl = ({ className = "" }) => {
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true" data-testid="aurora-swirl">
      {/* slow rotating conic swirl */}
      <div
        className="aurora-spin absolute left-1/2 top-1/2 h-[120vmax] w-[120vmax] -translate-x-1/2 -translate-y-1/2 opacity-[0.28] blur-[60px] will-change-transform"
        style={{
          background:
            "conic-gradient(from 90deg at 50% 50%, hsl(var(--accent) / 0.9), hsl(199 89% 55% / 0.7), transparent 35%, hsl(var(--accent) / 0.6), hsl(178 70% 45% / 0.7), transparent 72%, hsl(199 89% 55% / 0.8))",
        }}
      />
      {/* drifting color blobs */}
      <div
        className="aurora-a absolute -left-[10%] top-[-15%] h-[55vmax] w-[55vmax] rounded-full blur-[90px] will-change-transform"
        style={{ background: "radial-gradient(circle at 30% 30%, hsl(var(--accent) / 0.55), transparent 62%)" }}
      />
      <div
        className="aurora-b absolute -right-[12%] top-[5%] h-[50vmax] w-[50vmax] rounded-full blur-[90px] will-change-transform"
        style={{ background: "radial-gradient(circle at 60% 40%, hsl(199 89% 58% / 0.5), transparent 62%)" }}
      />
      <div
        className="aurora-a absolute bottom-[-20%] left-[25%] h-[45vmax] w-[45vmax] rounded-full blur-[100px] will-change-transform"
        style={{ background: "radial-gradient(circle at 50% 50%, hsl(178 70% 48% / 0.4), transparent 62%)" }}
      />
      {/* fine grain / dot texture */}
      <div
        className="absolute inset-0 opacity-[0.4] mix-blend-soft-light"
        style={{
          backgroundImage: "radial-gradient(hsl(0 0% 100% / 0.5) 0.5px, transparent 0.5px)",
          backgroundSize: "3px 3px",
        }}
      />
      {/* fade the swirl into the page background */}
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-b from-transparent to-background" />
    </div>
  );
};
